module.exports = __webpack_public_path__ + "static/media/1022844.74785e91.png";